import type { ActivityMeta } from '@/models/Activity';

import { answerActivityMetaMap } from './answer';
import { listenActivityMetaMap } from './listen';
import { readActivityMetaMap } from './read';
import { watchActivityMetaMap } from './watch';
import { writeActivityMetaMap } from './write';

export const activityMetaMap: Record<number, ActivityMeta> = {
  ...answerActivityMetaMap,
  ...listenActivityMetaMap,
  ...readActivityMetaMap,
  ...watchActivityMetaMap,
  ...writeActivityMetaMap,
};
